export function isharrisbruno() {
  const url = window.location.href;
  return url.includes("harris-bruno-connect");
}
